import { WorkspacePremium } from '@mui/icons-material'
import { Box, SxProps, Typography } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

interface IndustryOrSector {
    industry?: { value: string }
    sector?: { value: string }
    topTier?: boolean
}

interface IndustryOrSectorListProps {
    items: IndustryOrSector[]
    sx?: SxProps
    limit?: number
}

const noWrapStyles = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}

const IndustryOrSectorList = ({
    items,
    sx,
    limit,
}: IndustryOrSectorListProps) => {
    const sortedItems = [...items].sort(
        (a, b) => Number(b.topTier) - Number(a.topTier)
    )
    let itemsToDisplay = sortedItems
    let extraItems = 0
    if (limit) {
        extraItems = sortedItems.length - limit
        itemsToDisplay = sortedItems.slice(0, limit)
    }
    return (
        <Box
            sx={{
                ...noWrapStyles,
                ...sx,
            }}
            title={sortedItems
                .map((item) => item.industry?.value || item.sector?.value)
                .join(', ')}
        >
            {items.length > 0 ? (
                <>
                    {itemsToDisplay.map((item, index) => (
                        <Box
                            key={
                                `${item.industry?.value}-${index}` ||
                                `${item.sector?.value}-${index}` ||
                                `industryOrSector-${index}`
                            }
                            sx={{
                                ...noWrapStyles,
                                flexWrap: 'nowrap',
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginRight: getPxAsRem(4),
                                flexGrow: 0,
                                flexShrink: 0,
                                maxWidth: '100%',
                                height: '100%',
                            }}
                        >
                            {item.topTier && (
                                <WorkspacePremium
                                    color="primary"
                                    sx={{
                                        width: getPxAsRem(12),
                                        height: getPxAsRem(12),
                                        marginRight: getPxAsRem(4),
                                    }}
                                />
                            )}
                            <Typography
                                variant="body2"
                                component={'span'}
                                color={item.topTier ? 'primary' : 'action'}
                                sx={{
                                    ...noWrapStyles,
                                }}
                            >
                                {`${item.industry?.value || item.sector?.value || '-'}${index < items.length - 1 ? ',' : ''}`}
                            </Typography>
                        </Box>
                    ))}
                    {extraItems && extraItems > 0 ? (
                        <Typography
                            component={'span'}
                            variant="body2"
                            color="action"
                        >{` +${extraItems}`}</Typography>
                    ) : (
                        ''
                    )}
                </>
            ) : (
                <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                        ...noWrapStyles,
                        flexWrap: 'nowrap',
                    }}
                >
                    -
                </Typography>
            )}
        </Box>
    )
}

export default IndustryOrSectorList
